// src/services/chatPolicyApi.js
import api from './api';

// Catálogo
export const getCatalog       = ()       => api.get('/chat-policies/catalog').then(r => r.data);
export const refreshCatalog   = ()       => api.post('/chat-policies/catalog/refresh').then(r => r.data);
export const searchUsers      = (q, filters = {}) => api.get('/chat-policies/users-search', {
    params: { q, ...filters },
}).then(r => r.data);

// Privilege
export const getPrivilege     = ()       => api.get('/chat-policies/privilege').then(r => r.data);
export const updatePrivilege  = (body)   => api.patch('/chat-policies/privilege', body).then(r => r.data);

// Protections
export const listProtections  = ()       => api.get('/chat-policies/protections').then(r => r.data);
export const createProtection = (body)   => api.post('/chat-policies/protections', body).then(r => r.data);
export const updateProtection = (id, b)  => api.patch(`/chat-policies/protections/${id}`, b).then(r => r.data);
export const deleteProtection = (id)     => api.delete(`/chat-policies/protections/${id}`).then(r => r.data);

// Tester
export const testPolicy = (fromUserId, toUserId) =>
    api.post('/chat-policies/test', { fromUserId, toUserId }).then(r => r.data);

export const testBulk = (userId, mode = 'fromUser', limit = 200) =>
    api.post('/chat-policies/test-bulk', { userId, mode, limit }).then(r => r.data);

// Preview de impacto
export const previewImpact = (mode, criteria) =>
    api.post('/chat-policies/preview', { mode, criteria }).then(r => r.data);
